import type { Filters, FilterType } from '../../../model/filters/types';

export const SET_ALL_FILTERS = 'state.actions.filters.SET_ALL_FILTERS' as const;

export type SetAllFiltersAction = {
	type: typeof SET_ALL_FILTERS;
	payload: {
		filters: Filters;
	};
	meta: {
		filterType: FilterType | undefined;
	};
};

export const setAllFilters = (filters: Filters, filterType?: FilterType): SetAllFiltersAction => ({
	type: SET_ALL_FILTERS,
	payload: {
		filters,
	},
	meta: {
		filterType,
	},
});

export type Action = SetAllFiltersAction;
